import { Button, Typography } from "@mui/material";

/* eslint-disable max-len */
import React from "react";
import { useLogout } from "../../../services/user/user.service";
import { useModal } from "../../../context/ModalContext";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useHospitalDetailsListStore } from "../../../hooks/redux-hooks/hospital-details-list-store/hospital-details-list-store";
import { useAllServiceStatusStore, useBookingAppointmentTypeStore } from "../../../hooks";
import { DUPLICATE_ALERT_KEY, MODALS } from "../../../config/params";

const LogoutModal = () => {
  const { closeModal, openModal } = useModal();
  const { logout } = useLogout();
  const { setIsHospitalListUpdated } = useHospitalDetailsListStore();
  const { setIsServiceStatusUpdated } = useBookingAppointmentTypeStore();
  const { isUrgentCareOnly }=useAllServiceStatusStore();


  const handleLogout = () => {
    userActivityLogger(MIXPANEL_EVENTS.LOGOUT, {
    });
    setIsHospitalListUpdated(false);
    setIsServiceStatusUpdated(false);
    localStorage.removeItem(DUPLICATE_ALERT_KEY);
    logout();
  };

  const handleKeepLoggedInCta = () => {
    if (isUrgentCareOnly) {
      openModal(MODALS.URGENT_CARE_TRANSITION_MODAL);
    } else {
      closeModal();
    }
  };

  return (
    <div>
      <Typography
        align="center"
        variant="h3"
        component="div"
        sx={{ mb: 6, fontWeight: "bold" }}
      >
        Are you sure you want to log out?
      </Typography>

      <Button
        id="LogoutModalButton"
        color="primary"
        type="button"
        sx={{ mb: 2, fontFamily: "geograph-regular", textTransform: "none" }}
        fullWidth
        onClick={handleKeepLoggedInCta}

      >
        Keep me logged in
      </Button>

      <Button
        id="LogoutModalButton"
        variant="outlined"
        type="button"
        sx={{ fontFamily: "geograph-regular", textTransform: "none" }}
        fullWidth
        onClick={handleLogout}

      >
        Yes, I want to log out
      </Button>

    </div>
  );
};

export default LogoutModal;
